<template>
  <div style="position: relative;">
    <main-toolbar>
      <v-toolbar-title>Machines</v-toolbar-title>
      <!-- <v-btn
        text
        @click="editRecordId = 'new'"
        :disabled="loading || machinesLoading"
      >
        <v-icon small>fa-plus</v-icon>
        <div v-if="!appSmall">&nbsp;Add Machine</div>
      </v-btn> -->
    </main-toolbar>
    <v-container
      style="position: absolute; top: 0; left: 0; width: 100%; z-index: 10;"
      class="text-center"
      fluid
      align-center
      justify-center
      v-if="loading"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-container>
    <v-simple-table
      v-if="machines.length"
      class="elevation-1"
      fill-height
    >
      <thead>
        <tr>
          <th style="width: 80px;" v-if="!readOnly"></th>
          <th>#</th>
          <th>Name</th>
          <th>Location</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="machine in machines"
          :key="machine.id"
        >
          <td class="layout pt-1" v-if="!readOnly">
            <v-btn
              icon
              small
              color="black"
              :disabled="loading || machinesLoading"
              @click="editRecordId = machine.id"
            >
              <v-icon small>fa-edit</v-icon>
            </v-btn>
            <v-btn
              class="ml-0"
              icon
              small
              color="black"
              :disabled="loading || machinesLoading"
              @click="deleteItem(machine)"
            >
              <v-icon small>fa-trash-alt</v-icon>
            </v-btn>
          </td>
          <td>{{ machine.id }}</td>
          <td>{{ machine.name || '' }}</td>
          <td>{{ machine.location || '' }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <MachineEditor
      v-if="editRecordId"
      :recordId="editRecordId"
      @close="editRecordId = null"
    />
  </div>
</template>

<script>
import MachineEditor from './MachineEditor'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    MachineEditor
  },
  data () {
    return {
      loading: false,
      editRecordId: null
    }
  },
  computed: {
    ...mapState('machines', {
      machinesLoading: 'loading',
      machines: 'data'
    })
  },
  methods: {
    ...mapActions('machines', {
      findMachines: 'find',
      deleteMachine: 'delete'
    }),
    async deleteItem (item) {
      if (!window.confirm('Are you sure you want to delete this machine?')) {
        return
      }
      this.loading = true
      try {
        await this.deleteMachine(item.id)
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    }
  },
  async created () {
    this.loading = true
    try {
      await this.findMachines()
      this.loading = false
    } catch (e) {
      this.loading = false
      throw e
    }
  }
}
</script>
